<template>
    <div class="guide">
        <div class="static-body-card">
            <div class="guide__title text-w4">接入指南</div>
            <div class="guide__top flex flex--align-center flex--justify-center">
                <div class="guide__top__unit flex flex--direction-column flex--align-center flex--justify-center">
                    <div class="guide__grey-circle guide__top__circle text-w3">1</div>
                    <div class="guide__top__text text-w7 text-12 text-lh-16">购选服务</div>
                </div>
                <div class="guide__top__splitter"></div>
                <div class="guide__top__unit flex flex--direction-column flex--align-center flex--justify-center">
                    <div class="guide__grey-circle guide__top__circle text-w3">2</div>
                    <div class="guide__top__text text-w7 text-12 text-lh-16">用户注册</div>
                </div>
                <div class="guide__top__splitter"></div>
                <div class="guide__top__unit flex flex--direction-column flex--align-center flex--justify-center">
                    <div class="guide__grey-circle guide__top__circle text-w3">3</div>
                    <div class="guide__top__text text-w7 text-12 text-lh-16">密钥创建</div>
                </div>
                <div class="guide__top__splitter"></div>
                <div class="guide__top__unit flex flex--direction-column flex--align-center flex--justify-center">
                    <div class="guide__top__circle text-w3">4</div>
                    <div class="guide__top__text text-w7 text-12 text-lh-16">正式接入</div>
                </div>
            </div>
            <div class="guide__title-2 text-w4">只需4步，轻松完成接入！</div>
            <div class="guide__bottom__box flex flex--align-center">
                <div class="guide__bottom__circle">
                    <i class="ivu-icon iconfont iconshopping_cart-24px1"></i>
                </div>
                <div class="guide__bottom__text-box">
                    <div class="guide__bottom__text-box__title text-w5">1. 购选服务</div>
                    <div class="guide__bottom__text-box__content text-w4 text-14" v-html="$options.filters.formatTextWithLink(guideContents[0])"></div>
                </div>
            </div>
            <div class="guide__bottom__box flex flex--align-center">
                <div class="guide__bottom__circle">
                    <i class="ivu-icon iconfont iconadmin_panel_settings-24px"></i>
                </div>
                <div class="guide__bottom__text-box">
                    <div class="guide__bottom__text-box__title text-w5">2. 用户注册</div>
                    <div class="guide__bottom__text-box__content text-w4 text-14" v-html="$options.filters.formatTextWithLink(guideContents[1])"></div>
                </div>
            </div>
            <div class="guide__bottom__box flex flex--align-center">
                <div class="guide__bottom__circle">
                    <i class="ivu-icon iconfont iconvpn_key-24px1"></i>
                </div>
                <div class="guide__bottom__text-box">
                    <div class="guide__bottom__text-box__title text-w5">3. 密钥创建</div>
                    <div class="guide__bottom__text-box__content text-w4 text-14" v-html="$options.filters.formatTextWithLink(guideContents[2])"></div>
                    <div class="text-14 text-w4" style="margin-top: 16px; line-height: 24px; color: #51458B">
                        <span class="text-14 text-w7" style="line-height: 24px; color: #EF6C00">注：</span>
                        一个密钥只能调用一种API服务类型。例如您之前购买了体素肤知汇，此次又购买了体素肤美汇，需要再次创建一个可以调用体素肤美汇的密钥。
                    </div>
                </div>
            </div>
            <div class="guide__bottom__box flex flex--align-center">
                <div class="guide__bottom__circle">
                    <i class="ivu-icon iconfont iconsettings_ethernet-24px"></i>
                </div>
                <div class="guide__bottom__text-box">
                    <div class="guide__bottom__text-box__title text-w5">4. 正式接入</div>
                    <div class="guide__bottom__text-box__content text-w4 text-14" v-html="$options.filters.formatTextWithLink(guideContents[3])"></div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import guideData from "@/assets/staticData/guide.js";
export default {
    name: 'guide',
    data() {
        return {
            guideContents: guideData
        }
    }
}
</script>
<style lang="less">
    @prefix: ~'guide';
    .@{prefix} {
        background: #ECEFF1;
        user-select: none;

        &__title {
            font-size: 31px;
            letter-spacing: -0.86;
            line-height: 48px;
            color: rgba(black, 0.54);
            margin-top: 4px;
            margin-bottom: 28px;
        }

        &__top {
            width: 976px;
            height: 224px;
            background: #51458B;
            border-radius: 24px;
            box-shadow: 0 24px 38px 3px rgba(black, 0.1), 0 9px 46px 8px rgba(black, 0.08), 0 11px 15px 0 rgba(black, 0.16);

            &__text {
                margin-top: 9px;
                letter-spacing: 1;
                color: white;
            }

            &__circle {
                width: 88px;
                height: 88px;
                background: rgba(white, 0.16);
                border-radius: 50%;
                text-align: center;
                vertical-align: middle;
                color: white;
                font-size: 56px;
                letter-spacing: -4;
            }

            &__splitter {
                width: 152px;
                height: 4px;
                border-radius: 4px;
                background: #50E3C2;
                margin: 0 8px 25px 8px;
            }
        }

        &__title-2 {
            font-size: 31px;
            line-height: 40px;
            color: rgba(black, 0.54);
            margin-top: 56px;
            margin-bottom: 8px;
        }

        &__bottom {
            &__box {
                margin-top: 8px;
                width: 976px;
                padding: 24px 16px;
                border-radius: 16px;
                background: #ECEFF1;
            }

            &__circle {
                width: 88px;
                height: 88px;
                background: rgba(black, 0.08);
                border-radius: 50%;
                color: #51458B;
                padding: 16px;

                & .ivu-icon {
                    font-size: 56px;
                }
            }

            &__text-emphasize {
                font-weight: 400;
                font-size: 14px;
                line-height: 24px;
                color: #51458B;
            }

            &__text-link {
                font-weight: 500;
                font-size: 14px;
                line-height: 24px;
                color: #7C4DFF;
                text-decoration: underline;
            }

            &__text-box {
                margin-left: 32px;
                width: 824px;
                &__title {
                    color: #51458B;
                    font-size: 21px;
                    letter-spacing: 1.35;
                    line-height: 40px;
                }
                &__content {
                    color: rgba(black, 0.87);
                    line-height: 24px;
                    
                }
            }
        }
    }
    @media only screen and (max-width: 768px) {
    .@{prefix} {
        margin-top: -48px;
        padding-top: 20px;
        padding-bottom: 16px;

        &__title {
            font-size: 21px;
            line-height: 28px;
            margin-left: 16px;
        }

        &__top {
            margin: 0 8px;
            padding: 0 16px;
            width: calc(100% - 16px);
            height: 112px;
            border-radius: 16px;

            &__circle {
                width: 48px;
                height: 48px;
                font-size: 30px;
                line-height: 48px;
            }

            &__splitter {
                width: auto;
                flex-grow: 1;
            }
        }

        &__title-2 {
            margin-top: 24px;
            font-size: 21px;
            line-height: 28px;
            margin-left: 16px;
        }

        &__bottom {
            &__box {
                margin: 0 8px;
                width: calc(100% - 16px);
                align-items: flex-start;
            }

            &__circle {
                flex-shrink: 0;
                width: 48px;
                height: 48px;
                padding: 9px;

                & .ivu-icon {
                    font-size: 30px;
                }
            }

            &__text-box {
                margin-left: 16px;
                width: auto;

                &__title {
                    font-size: 18px;
                    line-height: 21px;
                    margin-bottom: 4px;
                }
            }
        }
    }
    }
</style>